<div class="row">
    <div class="large-3 medium-6 small-12 columns">
        <mat-spinner></mat-spinner>
    </div>
    <div class="large-9 medium-6 small-12 columns" class="grade-submitting-text">
        <div *ngFor="let item of validationStatusList">
            <div class="row">
                <div class="large-12 medium-12 small-12 columns">
                    {{item.course.termCodeDescription}} {{item.course.subjectCode}} {{item.course.courseNumber}} {{item.course.sectionNumber}} ({{item.course.crn}})
                </div>
            </div>
            <div class="row">
                <div class="large-12 medium-12 small-12 columns">
                    <div *ngIf="item.gradeValidationStatus.totalCount > 0 ">
                        {{item.gradeValidationStatus.currentCount}} of {{item.gradeValidationStatus.totalCount}} grades have been submitted.
                    </div>

                    <div *ngIf="item.gradeValidationStatus.totalCount === 0 ">
                        Submitting grades.<br> Please wait.
                    </div>
                </div>
            </div>


        </div>

    </div>
</div>